import { useState } from 'react';
import { supabase } from '../lib/supabaseClient';

export const useSecuritySettings = () => {
  const [loading, setLoading] = useState(false);

  const updatePassword = async (email, currentPassword, newPassword) => {
    setLoading(true);
    try {
      // 1. Verify current password by attempting to sign in
      const { error: signInError } = await supabase.auth.signInWithPassword({
        email,
        password: currentPassword
      });
      if (signInError) {
        throw new Error('Current password is incorrect.');
      }

      // 2. Update password on auth user record
      const { error } = await supabase.auth.updateUser({
        password: newPassword
      });
      if (error) throw error;
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  };

  const logoutOtherSessions = async () => {
    setLoading(true);
    try {
      // Supabase's newer GoTrue client supports scope: 'others' 
      // which invalidates all sessions except the current one.
      const { error } = await supabase.auth.signOut({ scope: 'others' });
      if (error) throw error;
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  };

  return {
    updatePassword,
    logoutOtherSessions,
    loading
  };
};
